var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMarketing24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_marketing24x24",
    transform: "translate(-21.835 -389)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M225.431,11.8l-7.384-7.381a1.113,1.113,0,1,0-1.569,1.568l7.381,7.381a1.113,1.113,0,0,0,1.568-1.568Z",
    transform: "translate(-188.145 385.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M139.983,82.9l-.052.278a12.309,12.309,0,0,1-2.437,5.324l3.723,4.015a10.733,10.733,0,0,1,4.913-2.655l.258-.056Z",
    transform: "translate(-113.201 311.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M33.368,256.989l-2.745,2.744a1.663,1.663,0,0,0,0,2.352l1.568,1.568a1.663,1.663,0,0,0,2.352,0l2.744-2.744Zm.392,4.312a.557.557,0,0,1-.784-.784l.784-.784a.557.557,0,0,1,.784.784Z",
    transform: "translate(-8.301 140.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M195.3,349.742l.754-.754a1.662,1.662,0,0,0,0-2.351l-.557-.557a10.494,10.494,0,0,0-.892.675l.669.67a.557.557,0,0,1,0,.784l-.767.767-1.127-1.092-1.568,1.568,2.515,2.438a1.113,1.113,0,0,0,1.568-1.569Z",
    transform: "translate(-164.352 54.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M332.419,0a.557.557,0,0,0-.557.557V1.67a.557.557,0,0,0,1.113,0V.557A.557.557,0,0,0,332.419,0Z",
    transform: "translate(-299.377 389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M423.527,120h-1.113a.557.557,0,1,0,0,1.113h1.113a.557.557,0,1,0,0-1.113Z",
    transform: "translate(-386.248 273.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M393.915,30.162a.556.556,0,0,0-.784,0l-1.113,1.113a.557.557,0,1,0,.784.784l1.113-1.113a.556.556,0,0,0,0-.784Z",
    transform: "translate(-357.354 360.109)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMarketing24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_marketing24x24.80ed84f163ec178ff72df4f274c4041a.svg";